import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

export const useCleanupArchivedBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesWorkflow.cleanup.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success(`Batch was cleaned successfully!`);
    },
    onError: (error) => {
      showErrorToast(error, 'Error cleaning the batch!');
    },
  });
};
